// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"582ff6b6","453":"61263008","456":"e29a40d7","515":"c660263d","597":"aa498dd5","712":"6cc0ac9b"}[chunkId] + ".chunk.js";
};